import './Footer.css'

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className='footer'>
        <p>© {currentYear} kevinmuindi10@gmail.com | Get in Touch: +254 704 230 589</p>
        <p>Privacy · Terms · Sitemap · Company Details</p>
        <p>
          Developed by{' '}
          <a 
            href="https://muindikelvin.github.io/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer__link"
          >
            Kelvin Muindi
          </a>
          {' · '}
          <a 
            href="https://github.com/MuindiKelvin/amazon-clone" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer__link"
          >
            View Source Code
          </a>
        </p>
    </div>
  );
}

export default Footer;